import {
  companyHasSinglePermission,
  userHasAnyPermission,
  userHasSinglePermission,
} from 'util/PermissionsUtils';
import { Permission, Permission as P } from 'common/models/Permissions';

export const AllowContactsModule = () =>
  userHasSinglePermission(P.Contacts) && companyHasSinglePermission(P.Contacts);
export const AllowContactsAddEdit = () =>
  userHasSinglePermission(P.ContactsAddEdit) && companyHasSinglePermission(P.ContactsAddEdit);
export const AllowContactsDelete = () =>
  userHasSinglePermission(P.ContactsDelete) && companyHasSinglePermission(P.ContactsDelete);
export const AllowContactsReportsAccess = () => userHasSinglePermission(P.ContactsReports);
export const AllowContactsImport = () =>
  userHasAnyPermission([Permission.OfficeAdministrator, Permission.SystemAdministrator]);
